import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Heading, HStack, Icon } from "@chakra-ui/react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

import { RoutesMap } from "../../../../../routes";

export const ProfilePageDocuments: FC = () => {
  const navigate = useNavigate();

  const goToDocuments = () => {
    navigate(RoutesMap.documents);
  };

  return (
    <HStack justifyContent="space-between" mt="20px" cursor="pointer" onClick={goToDocuments}>
      <Heading>Документы</Heading>
      <Icon boxSize="16px" ml="2px" as={ChevronRightIcon} color="gray.600" strokeWidth="2px" />
    </HStack>
  );
};
